import { BinaryType } from "../@types/Binary";
import { Arquitecture } from "./Arquitecture"
import { Downloader } from "./Donwloader";
import * as fs from "fs";
import * as path from "path";
import * as os from "os";

class Binary{
    private static isDownloading = false;
    private static downloadPromise: Promise<void> | null = null;

    static async ensureBinariesExist(): Promise<void> {
        if (this.isDownloading && this.downloadPromise) {
            await this.downloadPromise;
            return;
        }

        const binDir = this.getBinDir();
        const binaries = ['schema', 'query', 'sqlite'];
        
        // Check if all binaries exist
        const allExist = binaries.every(prefix => {
            const binaryInfo = Downloader.get(prefix);
            if (!binaryInfo.name) return false;
            const binaryPath = path.join(binDir, binaryInfo.name);
            return fs.existsSync(binaryPath);
        });

        if (allExist) {
            return;
        }

        // Download if not exists
        if (!this.isDownloading) {
            this.isDownloading = true;
            this.downloadPromise = this.downloadBinaries();
            
            try {
                await this.downloadPromise;
            } finally {
                this.isDownloading = false;
                this.downloadPromise = null;
            }
        }
    }

    private static async downloadBinaries(): Promise<void> {
        try {
            const binDir = this.getBinDir();
            await Downloader.download(binDir);
        } catch (error) {
            console.warn('⚠️ DBCube: Error descargando binarios:', (error as Error).message);
            console.log('🔧 Los binarios se intentarán descargar en la próxima ejecución');
        }
    }

    private static getBinDir(): string {
        // Try to find a suitable directory for binaries in order of preference
        const possibleDirs = [
            path.resolve(process.cwd(), '.dbcube', 'bin'),
            path.resolve(process.cwd(), 'node_modules', '.dbcube', 'bin'),
            path.resolve(__dirname, '..', 'bin'),
        ];

        // Use the first one that can be created or already exists
        for (const dir of possibleDirs) {
            try {
                if (!fs.existsSync(dir)) {
                    fs.mkdirSync(dir, { recursive: true });
                }
                
                
                return dir;
            } catch {
                // Try next directory
                continue;
            }
        }

        // Fallback to .dbcube directory in temp
        const tempDir = path.join(os.tmpdir(), '.dbcube', 'bin');
        fs.mkdirSync(tempDir, { recursive: true });
        return tempDir;
    }


    static async get(): Promise<BinaryType> {
        await this.ensureBinariesExist();
        
        const arch = new Arquitecture();
        const platform = arch.getPlatform(); 
        const architecture = arch.getArchitecture(); 
        const binDir = this.getBinDir();
        
        const getFullPath = (binaryName: string) => {
            return path.join(binDir, binaryName);
        };
        
        switch(platform){
            case "windows":
                if(architecture=="x86_64"){
                    return {
                        query_engine: getFullPath("query-engine-windows-x64.exe"),
                        schema_engine: getFullPath("schema-engine-windows-x64.exe")
                    };
                }
                if(architecture=="aarch64"){
                    return {
                        query_engine: getFullPath("query-engine-windows-arm64.exe"),
                        schema_engine: getFullPath("schema-engine-windows-arm64.exe")
                    };
                }
                break;
            case "linux":
                if(architecture=="x86_64"){
                    return {
                        query_engine: getFullPath("query-engine-linux-x64"),
                        schema_engine: getFullPath("schema-engine-linux-x64")
                    };
                }
                if(architecture=="aarch64"){
                    return {
                        query_engine: getFullPath("query-engine-linux-arm64"),
                        schema_engine: getFullPath("schema-engine-linux-arm64")
                    };
                }
                break;
            case "macos":
                if(architecture=="x86_64"){
                    return {
                        query_engine: getFullPath("query-engine-macos-x64"),
                        schema_engine: getFullPath("schema-engine-macos-x64")
                    };
                }
                if(architecture=="aarch64"){
                    return {
                        query_engine: getFullPath("query-engine-macos-arm64"),
                        schema_engine: getFullPath("schema-engine-macos-arm64")
                    };
                }
                break;
        }
        
        return {
            query_engine: "",
            schema_engine: ""
        };
    }
}

export { Binary }